<template>
  <div>
      <img :src="myImages[index].image">
  </div>
</template>

<script>
/* eslint-disable */
export default {
    props: {
      index: { type: Number, default: 0 },
      myImages: { type: Array, default: [] },
    },

    mounted() {
      this.myImages = [
        {
          image: 'http://dsmsb.ddns.info:88/logo/DSM.GIF'
        },
        {
          image: 'https://images.pexels.com/photos/255379/pexels-photo-255379.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
        },
        {
          image: 'https://images.pexels.com/photos/949587/pexels-photo-949587.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
        },

      ]

      setInterval(() => {
        this.index++;
        if (this.index > 2) {
          this.index = 0;
        }
      }, 1000);
    }
}
</script>